<template>
	<div class="section is-fullheight">
		<div class="container is-medium">
			<div class="section-body">
				<div class="section-item">
					<img src="@/assets/illustration.png">
				</div>
				<div class="section-title">
					Create click-worthy geo-specific Links
				</div>
				<div class="section-subtitle is-small">
					Direct your followers to the best shop choice based on their
					location
					with only one link.
				</div>
				<ValidationObserver
					ref="observer"
					v-slot="{ valid }"
					class="access-box"
					tag="form"
					@submit.prevent="onSignup"
				>
					<AppInput
						v-model="inputValue"
						size="small"
						placeholder="Your email"
						:rules="{ required: true, email: true }"
						mode="aggressive-touch"
					/>
					<AppButton
						size="medium"
						color="primary"
						:disabled="!valid"
					>
						Get an early access
					</AppButton>
				</ValidationObserver>
				<div class="item section-description">
					You're already registered? Please go to
					<router-link
						:to="{ name: 'Login'}"
						class="description-link"
					>
						Login.
					</router-link>
				</div>
			</div>
		</div>
		<div class="section-img">
			<img src="@/assets/mockup.png">
		</div>
	</div>
</template>

<script>

import { mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';

export default {
	name: 'Landing',

	components: {
		ValidationObserver,
	},

	data() {
		return {
			inputValue: '',
			formIsValid: false,
		};
	},

	watch: {
		inputValue: {
			async handler() {
				this.formIsValid = await this.$refs.observer.validate({ silent: true });
			},
			deep: true,
		},
	},

	methods: {
		...mapActions('auth', [
			'requestSignup',
			'getInvitationCode',
		]),
		async onSignup() {
			if (this.formIsValid) {
				try {
					await this.requestSignup({ EMailAddress: this.inputValue });
					this.$router.push({ name: 'MailRequest' });
				} catch (error) {
					this.$notify({
						type: 'warn',
						title: 'Already exist',
						text: 'You`re mail is already registered',
					});
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.section {
	position: relative;

	.section-subtitle {
		margin: $gap-3 0;
	}

	.section-body {
		position: relative;
		max-width: 592px;
		z-index: 20;
	}

	.section-item {
		width: 229px;
		height: 229px;
		margin-bottom: $gap-5;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.item {
		margin-top: $gap-3;

		.description-link {
			color: $color-primary-100;
		}
	}

	.section-img {
		position: absolute;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;

		img {
			position: relative;
			width: 804px;
			height: 664px;
		}
	}

	.access-box {
		width: 488px;
		display: flex;
		justify-content: space-between;
	}
}
</style>
